/**
 * Account-MyFiles Queries
 */
import { graphql } from 'react-apollo'
import gql from 'graphql-tag'

export const imagesQuery = gql`
  query getFiles {
    images: getUserFiles {
      id
      fileUrl
      type
      imported
      lowQuality: low_quality
      createdAt: created_at
    }
  }
`

export const deleteImageMutation = graphql(
  gql`
    mutation deleteImage($fileId: Int!) {
      deleteUserFile(fileId: $fileId) {
        message
      }
    }
  `,
  {
    name: 'deleteImage'
  }
)



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/MyFiles/data.ts